


//import PageToolbar from './components/PageToolbar.vue';
//import SignInSignOut from './components/SignInSignOut.vue';
import QaComponent  from './components/QaComponent.vue';
import ModelsComponent from './components/ModelsComponent.vue';

// Import our custom CSS
import './scss/styles.scss'
import './wxwidgets/wxwidgets.scss'



//import { createApp } from 'vue'
import UserManagerComponent from './components/admin/UserManagerComponent.vue';
import LoaderMonitoringComponent from './components/admin/LoaderMonitoringComponent.vue';
import ServerMonitoringComponent from './components/admin/ServerMonitoringComponent.vue';
import ReportingComponent from './components/admin/ReportingComponent.vue';

//export { createApp, WeatherSummary2Component };

//createApp(WeatherSummary2Component).mount('#app')


let VcComponentLoader = (function(){
    console.log("Starting VcAdminComponentLoader..." );
    const COMPONENTS={
       
       // 'PageToolbar':PageToolbar,
       // 'SignInSignOut':SignInSignOut,
        'QaComponent':QaComponent,
        'ModelsComponent':ModelsComponent,
        'UserManagerComponent':UserManagerComponent,
        'LoaderMonitoringComponent':LoaderMonitoringComponent,
        'ServerMonitoringComponent':ServerMonitoringComponent,
        'ReportingComponent':ReportingComponent,
    };
    
    window.VcAvailableComponents=(window.VcAvailableComponents && { ...window.VcAvailableComponents, ...COMPONENTS }) || COMPONENTS;
    /*
    let isReady=false;

    window.addEventListener("load",function(event) {
        isReady=true;

        attachComponents();
        
    },false);

    function attachComponents() {
        if (!window.VcComponents) {
            console.log("No VcComponents found..." );
            return;
        }

        window.VcComponents.forEach(item => {
            if (!COMPONENTS[item.component]) {
                console.log("Component not found..." +item.component);
                return;
            }
            console.log("Component being mounted..." +item.component);
            createApp(COMPONENTS[item.component]).mount(item.selector)
        });
    }
        */
})();



